import React from 'react'
import { useFetch } from '../../hooks/useFetch'
import { Container, Box, Grid, TextField, Typography, Button, Divider, Card, Paper, CardActions, CardContent } from '@mui/material/'
import { useState, useEffect } from 'react';
import SelectedStudent from '../SelectedStudent'
import ViewCarryOvers from './ViewCarryOvers'
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
    GridHeader,
    GridFooter,
    GridFooterContainer,
    GridFooterPlaceholder

} from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewCourseFeesForQuote from './ViewCourseFeesForQuote'
import ViewOrderTotal from './ViewOrderTotal'
import RemoveCouse from './RemoveCouse'
function ViewOrderSummary({ orderId }) {



    const [tableData, setTableData] = useState([])
    const { error, errorMessage, isPending, data } = useFetch(`https://dcregapi.bi-oss.co.za/orders/details/${orderId}`)

    useEffect((tableData) => {
        if (data) {
            setTableData(data)

        }


    }, [data])






    const columns = [

        { field: 'courseCode', headerName: 'Code:', width: 150 },
        { field: 'courseName', headerName: 'Course:', width: 400 },
        { field: 'courseFee', headerName: 'Fee::', width: 150, float: 'right' },






    ];


    return (
        <>



            <DataGrid
                rows={tableData}
                columns={columns}



                sx={{ color: 'primary.main', borderColor: 'primary.main', borderWidth: 3, fontWeight: 'bold', m: 1, align: 'center', headerAlign: 'center', autoCapitalize: 'words' }}
                disableRowSelectionOnClick={true}
                disableColumnSelector={true}
                hideFooterRowCount
                hideFooterSelectedRowCount
                hideFooterPagination
                getRowId={(row) => row.id}
                autoHeight
                pageSize={(row) => row.length}
                components={{

                    Footer: () => <ViewOrderTotal orderId={orderId} />
                }}


            />




        </>

    )
}

export default ViewOrderSummary